const kfcLocalKeyPrefix = 'CHICKEN_COMMON_';
import { addDomain } from 'root/topic/api/utils';

const key = {
    citySearchHistory: 'CITY_SEARCH_HISTORY',
    totalPrice: 'TOTAL_PRICE',
    firstOrderTotalPrice: 'FIRST_ORDER_TOTAL_PRICE',
    reCashBackAmount: 'RE_CASH_BACK_AMOUNT',
    cartList: 'CART_LIST',
    restaurantData: 'RESTAURANT_DATA',
    confirmMenuList: 'COMFIRM_MENU_LIST',
    extraGood: 'EXTRA_GOOD',
    confirmUserDemand: 'USER_DEMAND',
    payErrorBack: 'PAY_ERROR_BACK',
    userBuyPhone: 'USER_BUY_PHONE',
    allowPromotion: 'ALLOW_PROMOTION',
    orderEatType: 'ORDER_EAT_TYPE',
    checkOrderMessage: 'CHECK_ORDER_MSG',
    buyerInfo: 'BUYER_INFO',
};

export default addDomain(key, kfcLocalKeyPrefix);
